import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

import type { CsvExportResponse } from '@/types/shortUrl'

const feUrlGroupingApi = createAggrApiInstance(aggr.FrontendUrlGroupingApi)

/** 查詢群組短網址列表 */
export const queryAllFEUrlGrouping = async (reqData: aggr.FEUrlGroupingQueryAllRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingQueryall(reqData))
  return res
}

/** 查詢群組短網址列表總筆數 */
export const queryAllFEUrlGroupingTotalCount = async (reqData: aggr.FEUrlGroupingQueryAllSubtotalRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingQueryallsubtotal(reqData))
  return res
}

/** 查詢群組內短網址清單 */
export const queryAllFEUrlGroupingUrlList = async (reqData: aggr.FEUrlGroupingQueryUrlListRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingQueryurllist(reqData))
  return res
}

/** 查詢群組內短網址清單總筆數 */
export const queryAllFEUrlGroupingUrlListTotalCount = async (reqData: aggr.FEUrlGroupingQueryUrlListSubtotalRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingQueryurllistsubtotal(reqData))
  return res
}

/** 建立短網址群組 */
export const createUrlGrouping = async (reqData: aggr.FEUrlGroupingCreateRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingCreate(reqData))
  return res
}

/** 建立短網址群組中的單一短網址 */
export const createUrlGroupingSingleUrl = async (reqData: aggr.FEUrlGroupingSingleUrlCreateRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingSingleurlcreate(reqData))
  return res
}

/** 刪除短網址群組 */
export const deleteUrlGrouping = async (reqData: aggr.FEUrlGroupingDeleteRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingDelete(reqData))
  return res
}

/** 更新短網址群組 */
export const updateUrlGrouping = async (reqData: aggr.FEUrlGroupingUpdateRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingUpdate(reqData))
  return res
}

/** 匯出選取的短網址群組為 CSV 檔案 */
export const exportSelectedGroups = async (reqData: aggr.FEUrlGroupingExportSelectedRq): Promise<CsvExportResponse> => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingExportselected(reqData))
  return res as unknown as CsvExportResponse
}

/** 查詢短網址群組詳細資料 */
export const fetchUrlGroupingDetail = async (reqData: aggr.FEUrlGroupingQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingQuery(reqData))
  return res
}

/** 新增標籤至短網址群組 */
export const appendTagToGroups = async (reqData: aggr.FEUrlGroupingAppendTagToUrlGroupRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingAppendtagtourls(reqData))
  return res
}

/** 移除短網址群組中的標籤 */
export const removeTagFromGroups = async (reqData: aggr.FEUrlGroupingRemoveTagFromUrlGroupRq) => {
  const res = await handleApiStatus(() => feUrlGroupingApi.urlgroupingRemovetagfromurls(reqData))
  return res
}
